import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "size-full flex flex-col overflow-y-scroll scroll-smooth no-scrollbar" };
const _hoisted_2 = { class: "flex-shrink-0 pt-1 pb-4" };
const _hoisted_3 = { class: "flex flex-wrap gap-2" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "font-medium" };
const _hoisted_6 = { class: "flex-1 pt-2" };
const _hoisted_7 = { class: "space-y-4" };
const _hoisted_8 = { class: "relative" };
const _hoisted_9 = { class: "relative" };
import { ref, watch } from "vue";
import { X } from "lucide-vue-next";
import { useHomeFilterStore } from "./homeFilterStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-size',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const sizeRanges = [
            { label: "≤36 mm", min: 0, max: 36 },
            { label: "37–40 mm", min: 37, max: 40 },
            { label: "41–42 mm", min: 41, max: 42 },
            { label: "43–45 mm", min: 43, max: 45 },
            { label: "≥46 mm", min: 46, max: 0 },
        ];
        const minSizeInput = ref(homeFilterStore.minSizeDiameter || "");
        const maxSizeInput = ref(homeFilterStore.maxSizeDiameter || "");
        watch(() => homeFilterStore.minSizeDiameter, (newVal) => {
            minSizeInput.value = newVal > 0 ? newVal : "";
        });
        watch(() => homeFilterStore.maxSizeDiameter, (newVal) => {
            maxSizeInput.value = newVal > 0 ? newVal : "";
        });
        const isRangeSelected = (range) => {
            return (homeFilterStore.minSizeDiameter === range.min &&
                homeFilterStore.maxSizeDiameter === range.max);
        };
        const selectSizeRange = (range) => {
            homeFilterStore.minSizeDiameter = range.min;
            homeFilterStore.maxSizeDiameter = range.max;
            minSizeInput.value = range.min > 0 ? range.min : "";
            maxSizeInput.value = range.max > 0 ? range.max : "";
        };
        const updateMinSize = () => {
            const value = Number(minSizeInput.value);
            homeFilterStore.minSizeDiameter = !isNaN(value) && value > 0 ? value : 0;
        };
        const updateMaxSize = () => {
            const value = Number(maxSizeInput.value);
            homeFilterStore.maxSizeDiameter = !isNaN(value) && value > 0 ? value : 0;
        };
        const clearMinSize = () => {
            minSizeInput.value = "";
            homeFilterStore.minSizeDiameter = 0;
        };
        const clearMaxSize = () => {
            maxSizeInput.value = "";
            homeFilterStore.maxSizeDiameter = 0;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm text-badge/70 pt-3 pb-2" }, " Case diameter (mm). Values like “41 mm” in listings are matched by the leading number. ", -1)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sizeRanges, (range) => {
                            return _createElementVNode("button", {
                                key: range.label,
                                type: "button",
                                onClick: ($event) => (selectSizeRange(range)),
                                class: _normalizeClass([
                                    'w-auto px-2 py-1 text-left rounded-lg border transition-all',
                                    isRangeSelected(range)
                                        ? 'bg-primary2 border-primary2 text-white'
                                        : 'bg-white border-badge/30 text-badge hover:border-primary2 hover:bg-primary2/5',
                                ])
                            }, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(range.label), 1)
                            ], 10, _hoisted_4);
                        }), 64))
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Minimum (mm)", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((minSizeInput).value = $event)),
                                    type: "number",
                                    placeholder: "0",
                                    min: "0",
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMinSize
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        minSizeInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (minSizeInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: clearMinSize,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear minimum"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-badge mb-2" }, "Maximum (mm)", -1)),
                            _createElementVNode("div", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((maxSizeInput).value = $event)),
                                    type: "number",
                                    placeholder: "No limit",
                                    min: "0",
                                    step: "1",
                                    class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge",
                                    onInput: updateMaxSize
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        maxSizeInput.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                (maxSizeInput.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        onClick: clearMaxSize,
                                        class: "absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-badge/10 rounded-full transition-colors",
                                        title: "Clear maximum"
                                    }, [
                                        _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
